import "./ReminderToasts.scss";
import { useTranslation } from "react-i18next";

// Popups for reminders that fire while the app is open. They stay until the
// user opens or closes them (the reminder is also in the notifications list).
function ReminderToasts({ toasts, onOpen, onClose }) {
  const { t } = useTranslation();
  if (toasts.length === 0) return null;

  return (
    <div className="reminder-toasts">
      {toasts.map((notification) => {
        const canOpen = notification.taskId || notification.todoListId;
        return (
          <div key={notification._id} className="reminder-toast" role="alert">
            <span className="material-symbols-outlined reminder-toast__icon">
              notifications_active
            </span>
            <div className="reminder-toast__text">
              <span className="reminder-toast__title">
                {t("notifications.types.reminder")}
              </span>
              <span className="reminder-toast__body">
                {notification.params?.title ?? notification.body}
              </span>
            </div>
            <div className="reminder-toast__actions">
              {canOpen && (
                <button
                  className="reminder-toast__open"
                  onClick={() => onOpen(notification)}
                >
                  {t("common.open")}
                </button>
              )}
              <button
                className="reminder-toast__close"
                onClick={() => onClose(notification)}
                title={t("common.close")}
                aria-label={t("common.close")}
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ReminderToasts;
